import { ACCELERATE_STATUS } from '../../consts'
import name from './name'

const selectSliceData = state => state[name]

const selectStatus = state => selectSliceData(state).status
const selectIsLoading = state => selectSliceData(state).isLoading
const selectHasError = state => selectSliceData(state).hasError
const selectIsEnabled = state => selectSliceData(state)?.status !== ACCELERATE_STATUS.NOT_ENABLED
const selectReport = state => selectSliceData(state).report
const selectProgress = state => selectSliceData(state).progress
const selectAssessmentProgress = state => selectSliceData(state).assessmentProgress
const selectRecommendations = state => selectSliceData(state).recommendations
const selectJourneySteps = state => selectSliceData(state).journeySteps

// Derived selectors for journey data
const selectHasCompletedAssessment = state => {
  const status = selectStatus(state)
  return [
    ACCELERATE_STATUS.ASSESSMENT_COMPLETED,
    ACCELERATE_STATUS.REPORT_VIEWED,
    ACCELERATE_STATUS.SKILL_BUILDER_IN_PROGRESS,
    ACCELERATE_STATUS.SKILL_BUILDER_COMPLETED
  ].includes(status)
}

const selectIsAssessmentInProgress = state => {
  const status = selectStatus(state)
  return status === ACCELERATE_STATUS.ASSESSMENT_IN_PROGRESS
}

const selectIsSkillBuilderPhase = state => {
  const status = selectStatus(state)
  return [
    ACCELERATE_STATUS.REPORT_VIEWED,
    ACCELERATE_STATUS.SKILL_BUILDER_IN_PROGRESS
  ].includes(status)
}

const selectIsJourneyComplete = state => {
  const status = selectStatus(state)
  return status === ACCELERATE_STATUS.SKILL_BUILDER_COMPLETED
}

const selectHasApplySkillsInteraction = state => selectSliceData(state).hasApplySkillsInteraction

const selectIsJourneyFullyCompleted = state => {
  return selectIsJourneyComplete(state) && selectHasApplySkillsInteraction(state)
}

const selectMastery = state => selectSliceData(state).mastery
const selectMomentum = state => selectSliceData(state).momentum

const selectBadges = state => selectSliceData(state).badges
const selectEarnedBadges = state => selectBadges(state)?.earned || []
const selectDismissedBadgeIds = state => selectSliceData(state).dismissedBadgeIds || []
const selectNewlyEarnedBadges = state => {
  const newlyEarned = selectBadges(state)?.newlyEarned || []
  const dismissed = selectDismissedBadgeIds(state)
  if (dismissed.length === 0) return newlyEarned
  const dismissedSet = new Set(dismissed)
  return newlyEarned.filter(b => !dismissedSet.has(b.id))
}

export {
  selectAssessmentProgress,
  selectBadges,
  selectDismissedBadgeIds,
  selectEarnedBadges,
  selectHasApplySkillsInteraction,
  selectHasCompletedAssessment,
  selectHasError,
  selectIsAssessmentInProgress,
  selectIsEnabled,
  selectIsJourneyComplete,
  selectIsJourneyFullyCompleted,
  selectIsLoading,
  selectIsSkillBuilderPhase,
  selectJourneySteps,
  selectMastery,
  selectMomentum,
  selectNewlyEarnedBadges,
  selectProgress,
  selectRecommendations,
  selectReport,
  selectStatus
}
